import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray app-content flex flex-column" }

import MainHeader from "../common/MainHeader.vue";
import MainCrumb from "../common/MainCrumb.vue";
import ScrollNoitce from "../common/ScrollNoitce.vue";
import SideBar from "../common/SideBar.vue";
import NoticeDialog from "@/components/util/NoticeDialog.vue";
import { RouteLocationMatched, useRoute } from "vue-router";
import { computed, ComputedRef, onMounted, ref } from "vue";
import { useUserStore } from "@/store";
import { useGlobalStore } from "@/store";
import { request } from "@/services";
type CrumbType = 'route' | 'routeWithTask' | 'taskOnly';

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutTask',
  setup(__props) {

const userStore = useUserStore();
const GlobalStore = useGlobalStore();
const route = useRoute();
const fullScreen: ComputedRef<boolean> = computed(() => {
  return GlobalStore.fullScreen && (route.meta.allowFull as boolean);
});
const parent: ComputedRef<string> = computed(() => {
  return route.meta && route.meta.parent ? (route.meta.parent as string) : "";
});
const showCrumb: ComputedRef<boolean> = computed(() => {
  return route.meta && route.meta.crumb ? (route.meta.crumb as boolean) : false;
});
const crumbs: ComputedRef<RouteLocationMatched[]> = computed(() => {
  return route.matched;
});
const crumbType: ComputedRef<CrumbType> = computed(() => {
  return route.meta && route.meta.crumbType ? (route.meta.crumbType as CrumbType) : "route";
});
const popNoticeInfos = ref<string[]>([]);
const rollNotice = ref("");
const scrollNoticeShow = ref(false);
// 关闭滚动公告
const closeScrollNotice = () => {
  scrollNoticeShow.value = false;
  GlobalStore.ScrollNoitceShow = false;
};
onMounted(() => {
  // 获取公告
  request.get("/common/get-notice").then((res) => {
    popNoticeInfos.value = res.data.popUpNotice;
    let now = new Date();
    let noticeTime = new Date(res.data.abortTime);
    if (now < noticeTime && GlobalStore.ScrollNoitceShow) {
      scrollNoticeShow.value = true;
      rollNotice.value = res.data.rollNotice;
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(MainHeader, { parent: parent.value }, null, 8, ["parent"]), [
      [_vShow, !fullScreen.value]
    ]),
    (scrollNoticeShow.value)
      ? (_openBlock(), _createBlock(ScrollNoitce, {
          key: 0,
          content: rollNotice.value,
          speed: 20,
          onCloseScrollNotice: closeScrollNotice
        }, null, 8, ["content"]))
      : _createCommentVNode("", true),
    (showCrumb.value)
      ? _withDirectives((_openBlock(), _createBlock(MainCrumb, {
          key: 1,
          crumbs: crumbs.value,
          type: crumbType.value
        }, null, 8, ["crumbs", "type"])), [
          [_vShow, !fullScreen.value]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, {
        class: _normalizeClass(["flex_1 mt20 mb20", { 'content-wrap': !fullScreen.value }])
      }, null, 8, ["class"])
    ]),
    _withDirectives(_createVNode(SideBar, null, null, 512), [
      [_vShow, !fullScreen.value && _unref(userStore).userInfo.source === 0 && !_unref(userStore).userInfo.ico]
    ]),
    _createVNode(NoticeDialog, { noticeInfos: popNoticeInfos.value }, null, 8, ["noticeInfos"])
  ], 64))
}
}

})